exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-loader[data-v-e8b674e8]{animation:loader-data-v-e8b674e8 1s infinite;display:flex}@keyframes loader-data-v-e8b674e8{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);

// exports
